var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.initpage),expression:"initpage"}],staticClass:"defaultpage"},[_c('FXJC',{staticClass:"fxjc",on:{"risk-detection":_vm.checkAndGo}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }